import axios from 'axios';
import { base_url } from '../utilities';

// Use plain axios for login (no interceptor needed for auth endpoints)
const authApi = axios.create({
  baseURL: base_url,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const loginUser = async (username, password) => {
  const response = await authApi.post('authorization/login', {
    username,
    password,
  });

  const data = response.data;

  // Handle both formats: direct response or nested in body
  let parsedData;
  if (data.body) {
    // Response has body wrapper (API Gateway format)
    parsedData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
  } else {
    // Direct response format
    parsedData = data;
  }

  if (parsedData.status === 'success') {
    const { tokens, user_id, username: uname, email, phone_number, name, group } = parsedData.data;

    // Store tokens
    localStorage.setItem('accessToken', tokens.AccessToken);
    localStorage.setItem('refreshToken', tokens.RefreshToken);
    localStorage.setItem('idToken', tokens.IdToken);
    localStorage.setItem('tokenExpiry', Date.now() + tokens.ExpiresIn * 1000);

    // Store user info
    const userInfo = {
      userId: user_id,
      username: uname,
      email,
      phoneNumber: phone_number,
      name,
      group,
    };
    localStorage.setItem('user', JSON.stringify(userInfo));

    return userInfo;
  }

  throw new Error(parsedData.message || 'Login failed');
};

export const logoutUserApi = async (username) => {
  try {
    const response = await authApi.post('authorization/logout', {
      username,
    });

    const data = response.data;

    // Handle both formats: direct response or nested in body
    let parsedData;
    if (data.body) {
      parsedData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
    } else {
      parsedData = data;
    }

    // Clear local storage regardless of response
    clearUserData();

    return parsedData;
  } catch (error) {
    // Still clear local storage even if API call fails
    clearUserData();
    throw error;
  }
};

export const clearUserData = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('user');
};

// Keep for backward compatibility
export const logoutUser = clearUserData;

export const getStoredUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const isTokenValid = () => {
  const expiry = localStorage.getItem('tokenExpiry');
  if (!expiry) return false;
  return Date.now() < parseInt(expiry, 10);
};